export default "__VITE_ASSET__Di953f7z__"